import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  risk_level: string;
  country: number;
}

export const useEditCountryRiskLevel = () => {
  const { authHeader } = useAuth();

  return useMutation(({ params, id }: { params: Params; id: number }) => {
    return axios.put(
      `${env.verifyServiceUrl}individual/country_risk_level/${id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
